// extracted by mini-css-extract-plugin
export var expireBanner = "Giveaway-module--expireBanner--b0fcc";
export var headerImage = "Giveaway-module--headerImage--90102";
export var hero = "Giveaway-module--hero--5eeb1";
export var testimonialCard = "Giveaway-module--testimonialCard--461b5";
export var userImage = "Giveaway-module--userImage--9834c";